import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import infoGenesisLogo from "../../assets/images/agilysys-dots.png";
import agilysysLogo from "../../assets/images/AgilysysLogo.png";
import { Input, Button, Dropdown, Checkbox, Spin, Select } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { GetAllApps, SearchTenants, clearCookies, FetchTenantEnvironment, FetchAccessDetails } from '../services/auth.service';
import { CreateQueryStringCookie } from "../services/cookie.service";

const OrgChooser = ({ OrgTenantId, OrgName }) => {
    const isSilkBrowser = /Silk\//i.test(navigator.userAgent);
    const currentYear = new Date().getFullYear();
    const [org, setOrg] = useState(OrgName);
    const [app, setApp] = useState(localStorage.getItem('app') ?? 'IG Configuration Manager');
    const [appList, setAppList] = useState([]);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [dropDownvisible, setdropDownVisible] = useState(false);
    const [agilysysSupportEnabled, setAgilysysSupport] = useState((localStorage.getItem('agilysysSupport')?.toLowerCase() === 'true') ?? false);
    const [authFlowEnabled, setAuthFlowEnabled] = useState(false);
    const [orgList, setOrgList] = useState([]);
    const [selectedOrgList, setSelectedOrgList] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        handleAuthFlow();
        GetAllApps().then(setAppList);

    }, []);
    const handleAuthFlow = async () => {
        if (window.location.pathname.toLowerCase() === '/igsupport' && await FetchAccessDetails()) {
            setAuthFlowEnabled(true);
            setAgilysysSupport(true);
            setIsFetching(true);
            let tenants = await SearchTenants("", true);
            setOrgList(tenants);
            if (OrgTenantId) {
                var tenant = tenants.find(x => x.value === OrgTenantId)
                setSelectedOrgList({ ...tenant, label: `${tenant.label} (${tenant.value})` });
                setOrg(tenant.label);
            }
            setIsFetching(false);
        }
    }
    const handleOrgChange = useCallback(({ target: { value } }) => {
        if (value !== null) {
            setOrg(value);
        }
    }, []);

    const handleOrgListChange = (selected) => {
        if (selected) {
            setSelectedOrgList(selected);
            setOrg(selected.label.split(' (')[0]);
        }
    };

    const handleSubmit = async () => {
        let tenants;
        if (selectedOrgList !== null) {
            tenants = [{ value: selectedOrgList.value, label: org }];
        } else {
            tenants = await SearchTenants(org);
        }
        if (tenants.length > 0) {
            const appDetailIndex = appList.findIndex(x => x.label === app)
            if (appDetailIndex >= 0) {
                let app = appList[appDetailIndex];
                let tenantId = tenants[0].value;
                let tenantName = tenants[0].label;
                let appName = app.url.replaceAll('/', '');
                await clearCookies(appName);
                let redirectapp = await FetchTenantEnvironment(tenantId, app.name);
                const redirectAppUrl = redirectapp ?? app.redirectapp;
                CreateQueryStringCookie(tenantId, tenantName, redirectAppUrl, agilysysSupportEnabled, appName);
                const isKdsPreview = app.name === 'kds'
                    && new URL(redirectAppUrl, window.location.origin).searchParams.get('previewOsd') === true;
                const requiresOtp = app.name === 'dmb' || (app.name === 'kds' && !isKdsPreview);
                if (requiresOtp) {
                    window.location.hash = `/otp?app=${encodeURIComponent(app.name)}`;
                } else {
                    window.location.assign(app.url);
                }
            }
        }
        else {
            setIsErrorVisible(true);
            ref.current.focus();
        }
    };
    const handleAppSelect = (app) => {
        setApp(app);
        localStorage.setItem('app', app);
        setdropDownVisible(false);
        ref.current.focus();
    }

    const handleClear = () => {
        setOrg(null);
        setSelectedOrgList(null);
        setIsErrorVisible(false);
    }
    const handleKeyDown = () => {
        if (isErrorVisible) {
            setIsErrorVisible(false);
        }
    }

    const NoContent = useMemo(() => {
        return isFetching ? <Spin size="small" /> : null;
    }, [isFetching])

    const handleDropDownHover = (e) => {
        e.preventDefault();
        setdropDownVisible(!dropDownvisible);
    }
    const handleCheckbox = (e) => {
        let supportEnabled = e.target.checked;
        setAgilysysSupport(supportEnabled);
        localStorage.setItem('agilysysSupport', supportEnabled)
    }
    return (
        <div className="appselector-container">
            <div className="left-container">
                <div className="loginbg">
                    <svg
                        id="Layer_2"
                        data-name="Layer 2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                    >
                        <defs></defs>
                        <g id="Web_UD_Icons" data-name="Web UD Icons">
                            <g id="IG_Logo" data-name="IG Logo">
                                <rect className="cls-2" width="24" height="24" />
                                <path
                                    className="cls-1"
                                    d="M14.93,6.91c0-2.46,2.26-4.43,4.81-3.92,1.55.31,2.8,1.56,3.11,3.11.5,2.55-1.46,4.8-3.92,4.8-2.2,0-4-1.8-4-4h0ZM1.5,14.51c0-4.24,3.51-7.66,7.78-7.5,3.86.14,7.06,3.33,7.21,7.19.17,4.28-3.25,7.8-7.49,7.8h0c-4.05,0-7.5-3.34-7.5-7.49Z"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
                <div className="ig-logo-container">
                    <img className="ig-logo" src={agilysysLogo} />
                </div>
                <div className="main-container">
                    <Dropdown
                        menu={{ items: appList, onClick: handleDropDownHover }}
                        open={dropDownvisible}
                        onOpenChange={setdropDownVisible}
                        dropdownRender={(menu) => (
                            <div className="dropdown">
                                {
                                    menu.props.items.map((item) => (
                                        <div className="dropdown-item" key={item.label} onClick={() => handleAppSelect(item.label)} >
                                            <img className="radio-icon" src={infoGenesisLogo} />
                                            {item.label}
                                        </div>
                                    ))
                                }
                            </div>
                        )}
                    >
                        <Button className="dropdown-button">
                            <span>
                                <img className="radio-icon" src={infoGenesisLogo} />
                                {app}
                            </span>
                            <DownOutlined className="dropdown-arrow" />
                        </Button>
                    </Dropdown>

                    <div className="form-field-container">
                        {authFlowEnabled ?
                            <div>
                                <label className="org-selection-text">
                                    Select Your Organization
                                </label>
                                <Select className="authEnabled org-select"
                                    notFoundContent={NoContent}
                                    labelInValue
                                    ref={ref}
                                    options={orgList.map(x => ({ value: x.value, label: `${x.label} (${x.value})` }))}
                                    onChange={(selected) => handleOrgListChange(selected)}
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                    style={{ width: '100%' }}
                                    allowClear
                                    value={selectedOrgList}
                                    showSearch={true}
                                    onClear={handleClear}
                                    dropdownStyle={{
                                        maxHeight: 'auto',
                                        overflowY: 'auto',
                                    }}
                                />
                            </div> :
                            <div>
                                <label className="org-selection-text">
                                    Enter Organization Name
                                </label>
                                <Input className="org-select"
                                    autoFocus={!isSilkBrowser}
                                    ref={ref}
                                    maxLength={50}
                                    onKeyDown={handleKeyDown}
                                    onChange={handleOrgChange}
                                    allowClear
                                    value={org}
                                    onClear={handleClear}
                                    onPressEnter={isSilkBrowser ? undefined : handleSubmit}
                                />
                                <div className={`org-selection-subtext ${isErrorVisible ? 'visible' : 'hide'}`}>
                                    {isErrorVisible && <label>Ensure your organization name is correct and proceed</label>}
                                </div>
                                <div className="checkbox-text">
                                    <Checkbox onChange={handleCheckbox} checked={agilysysSupportEnabled}>Agilysys Support</Checkbox>
                                </div>
                            </div>}
                        <Button className="button" type="primary" onClick={handleSubmit} block disabled={!org || app === null}>Proceed</Button>
                    </div>
                </div>

                <div className="footer-content">
                    <span className="copyright-content">
                        Copyright 1987-{currentYear}, Agilysys NV, LLC.All rights reserved.
                    </span>
                </div>
            </div>
            <div className="right-container">
                <img className="logoContainer" src={appList?.find(x => x.label === app)?.img} />
            </div>
        </div>
    );
};

export default OrgChooser;
